import React from 'react';

import { TSvgIcon } from '../types';

export const DoubleArrow2Icon: TSvgIcon = ({ color = '#FFB822', width = 25, height = 24 }): JSX.Element => {
    return (
        <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.5799 11.42L16.5399 5.77C16.1999 5.29 15.6499 5 15.0599 5C13.5699 5 12.7099 6.68 13.5699 7.89L16.4999 12L13.5699 16.11C12.6999 17.32 13.5699 19 15.0599 19C15.6499 19 16.2099 18.71 16.5499 18.23L20.5899 12.58C20.8299 12.23 20.8299 11.77 20.5799 11.42Z"
                fill={color}
            />
            <path
                d="M13.5799 11.42L9.54992 5.77C9.19992 5.29 8.64992 5 8.05992 5C6.56992 5 5.69992 6.68 6.56992 7.89L9.49992 12L6.56992 16.11C5.69992 17.32 6.56992 19 8.05992 19C8.64992 19 9.20992 18.71 9.54992 18.23L13.5899 12.58C13.8299 12.23 13.8299 11.77 13.5799 11.42Z"
                fill={color}
            />
        </svg>
    );
};
